import { render, staticRenderFns } from "./serviceOrganization.vue?vue&type=template&id=226bd4d0&scoped=true"
import script from "./serviceOrganization.vue?vue&type=script&lang=js"
export * from "./serviceOrganization.vue?vue&type=script&lang=js"
import style0 from "./serviceOrganization.vue?vue&type=style&index=0&id=226bd4d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226bd4d0",
  null
  
)

export default component.exports